<template>
  <div class="maxbox">
    <header class="header">
      <div class="logo-container">
        <div class="wallet-info">
          <div class="wallet-balance">余额: {{ walletBalanceTop }} USDT</div>
          <div class="wallet-balance">余额: {{ sbsBalance }} Tornado</div>
        </div>
        <img src="@/assets/images/ban-1.png" alt="Tornado Logo" class="logo">
      </div>
    </header><br>
    <main class="main">
      <section class="price-box">
        <div class="price-item">
          <p>Tornado 价格</p>
          <button class="reference-btn" 
 @mousedown="handleRefBtnMouseDown" 
 @mouseup="handleRefBtnMouseUp" 
 @mouseleave="handleRefBtnMouseUp"
 @touchstart="handleRefBtnMouseDown"
 @touchend="handleRefBtnMouseUp"
>参考</button>
        </div>
        <div class="price-range">
  <div class="exchange-rate price-box-item">
    <p>当前汇率</p>
    <h2>{{ exchangeRateFixed }} USDT / 1Tornado</h2>
  </div>
  <!-- 新增实时手续费展示卡片 -->
  <div class="fee-rate price-box-item">
    <p>交易手续费率</p>
    <h2>{{ exchangeFeeRate }} %</h2>
  </div>
</div>

        <button class="add-order-btn" @click="showBuyOrderModal = true">+ 快捷区挂买单</button>
        <!-- <button class="add-order-btn" @click="showSellOrderModal = true">+ 快捷区挂卖单</button> -->
        
        <!-- ✅ 新增：自定义挂卖单按钮 -->
        <button class="add-order-btn custom-sell-btn" @click="showCustomSellModal = true">+ 自定价挂卖单</button>
      </section>
      <section class="order-tabs">
        <button class="order-tab" @click="showMyBuyOrdersModal = true">我的买单</button>
        <button class="order-tab" @click="showMySellOrdersModal = true">我的卖单</button>
      </section><br>
      <section class="market-order-section">
        <div class="market-title">市场挂单</div>
        <div class="market-tabs">
          <button class="market-tab" :class="{ active: activeMarketTab === 'buy' }" @click="activeMarketTab = 'buy'">
            我要卖
          </button>
          <button class="market-tab" :class="{ active: activeMarketTab === 'sell' }" @click="activeMarketTab = 'sell'">
            我要买
          </button>
        </div>
        <div v-if="showTradeTimeTip" class="trade-time-tip">
          <p class="tip-title">开放时间</p>
          <p class="tip-time">{{ tradeStartTimeStr }} - {{ tradeStopTimeStr }}</p>
        </div>
        <div class="market-content">
          <div v-show="activeMarketTab === 'buy'" class="market-panel">
            <div class="book-tbody card-style-book-tbody">
              <div v-if="marketBuyOrders.length === 0" class="empty-tip">暂无买单</div>
              <div v-for="(item, idx) in marketBuyOrders" :key="`market-buy-${idx}`" class="order-card-item">
                <div class="card-left">
                  <p class="card-row">数量: {{ parseInt(item.remainAmount) }}/{{ parseInt(item.totalAmount || item.remainAmount) }}</p>
                  <p class="card-row">订单号: {{ item.orderId }}</p>
                  <p class="card-row">价格: {{ item.priceFixed }}</p>
                </div>
                <div class="card-right">
                  <button 
                    @click="!showTradeTimeTip && openSellModal(item.orderId, item.price)" 
                    class="sell-btn" 
                    :class="{ disabled: showTradeTimeTip }"
                  >
                    卖给TA
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- ✅ 我要买 → 显示所有用户自定义卖单 -->
          <div v-show="activeMarketTab === 'sell'" class="market-panel">
            <div class="book-tbody card-style-book-tbody">
              <div v-if="userSellOrders.length === 0" class="empty-tip">暂无用户挂单</div>
              <div v-for="(order, idx) in userSellOrders" :key="`user-sell-${idx}`" class="order-card-item">
                <div class="card-left">
                  <p class="card-row">价格: {{ order.priceFixed }} USDT</p>
                  <p class="card-row">剩余: {{ order.remainAmount }} / 总量: {{ order.totalAmount }}</p>
                  <p class="card-row">卖家: {{ order.seller.slice(0,6) }}...{{ order.seller.slice(-4) }}</p>
                  <p class="card-row">订单ID: {{ order.orderId }}</p>
                </div>
                <div class="card-right">
                  <button 
                    @click="openBuyFromOrderModal(order)" 
                    class="sell-btn"
                    :class="{ disabled: showTradeTimeTip || !order.isActive }"
                  >
                    买入
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- ========== 原有弹窗 ========== -->
      <div v-if="showBuyOrderModal" class="modal-overlay">
        <div class="modal-content">
          <div class="modal-header">
            <h2>创建买单</h2>
            <span class="close" @click="showBuyOrderModal = false">&times;</span>
          </div>
          <p>卖出价格（USDT/Tornado）</p>
          <div class="price-range price-box-item">
            <p>当前价格：${{ exchangeRateFixed }} USDT</p>
          </div>
          <div class="modal-body">
            <p>购买数量（Tornado）</p>
            <input type="number" placeholder="请输入购买数量" v-model="buyQuantity" class="quantity-input" @input="calculateUSDT">
            <p>需支付USDT:</p>
            <p class="total-usdt">{{ totalUSDT }} USDT</p>
            <button class="submit-btn" @click="exchangeUSDTForSBS">提交订单</button>
          </div>
        </div>
      </div>
      <div v-if="showSellOrderModal" class="modal-overlay">
        <div class="modal-content">
          <div class="modal-header">
            <h2>创建卖单</h2>
            <span class="close" @click="showSellOrderModal = false">&times;</span>
          </div>
          <div class="modal-body">
            <p>卖出价格（USDT/Tornado）</p>
            <div class="price-range price-box-item">
              <p>当前价格：${{ exchangeRateFixed }} USDT</p>
            </div>
            <p>卖出数量（Tornado）</p>
            <input type="number" placeholder="请输入卖出数量" v-model="sellQuantity" class="quantity-input" @input="calculateUSDTAfterFee">
            <p>扣除 {{ exchangeFeeRate }}% 手续费后可获得USDT:</p>
            <p class="total-usdt">{{ totalUSDTAfterFee }} USDT</p>
            <button class="submit-btn" @click="exchangeSBSForUSDT">提交订单</button>
          </div>
        </div>
      </div>
      <!-- ✅ 新增：自定义挂卖单弹窗 -->
      <div v-if="showCustomSellModal" class="modal-overlay">
        <div class="modal-content">
          <div class="modal-header">
            <h2>自定义挂卖单</h2>
            <span class="close" @click="showCustomSellModal = false">&times;</span>
          </div>
          <div class="modal-body">
            <p>自定义价格 (USDT/Tornado)</p>
            <input v-model="customSellPrice" type="number" class="quantity-input" placeholder="例如：0.001234">
            
            <p>卖出数量 (Tornado)</p>
            <input v-model="customSellAmount" type="number" class="quantity-input" placeholder="请输入数量">
            
            <p class="total-usdt">预计收入（扣除{{ exchangeFeeRate }}%手续费）: {{ (customSellPrice * customSellAmount * (1 - exchangeFeeRate / 100)).toFixed(6) }} USDT</p>
            <button class="submit-btn" @click="createCustomSellOrder">确认挂单</button>
          </div>
        </div>
      </div>
      <!-- ✅ 新增：买入他人自定义卖单 -->
      <div v-if="showBuyFromOrderModal" class="modal-overlay">
        <div class="modal-content">
          <div class="modal-header">
            <h2>买入 Tornado</h2>
            <span class="close" @click="showBuyFromOrderModal = false">&times;</span>
          </div>
          <div class="modal-body">
            <p>价格: {{ currentSellOrder?.priceFixed }} USDT</p>
            <p>可买数量: {{ currentSellOrder?.remainAmount }}</p>
            <input v-model="buyFromAmount" type="number" class="quantity-input" placeholder="买入数量">
            <p class="total-usdt">需支付: {{ (buyFromAmount * currentSellOrder?.price).toFixed(6) }} USDT</p>
            <button class="submit-btn" @click="buyFromSellOrder">确认买入</button>
          </div>
        </div>
      </div>
      <div v-if="showSellToOrderModal" class="modal-overlay">
        <div class="modal-content">
          <div class="modal-header">
            <h2>卖出 Tornado 到买单</h2>
            <span class="close" @click="showSellToOrderModal = false">&times;</span>
          </div>
          <div class="modal-body">
            <p>订单价格：{{ currentOrderPrice }} USDT</p>
            <p>卖出数量（必须整数）</p>
            <input type="number" v-model="sellToOrderAmount" class="quantity-input" placeholder="请输入整数数量" @input="calcSellToOrderUSDT">
            <p>可获得USDT (扣除 {{ exchangeFeeRate }}% 手续费):</p>
            <p class="total-usdt">{{ receiveUSDT }} USDT</p>
            <button class="submit-btn" @click="sellToBuyOrder">确认卖出</button>
          </div>
        </div>
      </div>
      <div v-if="showMyBuyOrdersModal" class="modal-overlay">
        <div class="modal-content">
          <div class="modal-header">
            <h2>我的买单记录</h2>
            <span class="close" @click="showMyBuyOrdersModal = false">&times;</span>
          </div>
          <div class="modal-body">
            <div v-for="(order, index) in myBuyTradeRecords" :key="`buy-${index}`" class="order-record">
              <div class="order-details">
                <p><span>状态: </span><span style="color: greenyellow;">已完成</span></p>
                <p><span>买入Tornado: </span><span style="color: yellow;">{{ order.amountSBS }} Tornado</span></p>
                <p><span>支付USDT: </span><span style="color: green;">{{ order.amountUSDT }} USDT</span></p>
                <p><span>成交价格: </span><span>{{ order.exchangePrice }} USDT/Tornado</span></p>
                <p><span>买入时间: </span><span>{{ formatTimestamp(order.timestamp) }}</span></p>
              </div>
            </div>
            <p v-if="myBuyTradeRecords.length === 0">暂无买单记录</p>
          </div>
        </div>
      </div>
      <!-- ✅ 升级：我的卖单 → 显示挂单 + 撤销功能 -->
      <div v-if="showMySellOrdersModal" class="modal-overlay">
        <div class="modal-content">
          <div class="modal-header">
            <h2>我的卖单</h2>
            <span class="close" @click="showMySellOrdersModal = false">&times;</span>
          </div>
          <div class="modal-body">
            <div v-for="(order, idx) in mySellOrders" :key="`my-sell-${idx}`" class="order-record">
              <p>价格: {{ order.priceFixed }} USDT</p>
              <p>总量: {{ order.totalAmount }} | 剩余: {{ order.remainAmount }}</p>
              <p>状态: {{ order.isActive ? '挂单中' : '已取消/已成交' }}</p>
              <button 
                v-if="order.isActive" 
                class="submit-btn" 
                style="background:red"
                @click="cancelMySellOrder(order.orderId)"
              >
                撤销挂单
              </button>
            </div>
            <p v-if="mySellOrders.length === 0">暂无挂单</p>
            <hr><br>
            <h3>历史成交</h3>
            <div v-for="(order, index) in mySellTradeRecords" :key="`sell-${index}`" class="order-record">
              <div class="order-details">
                <p><span>状态: 已成交</span></p>
                <p><span>卖出: {{ order.amountSBS }}</span></p>
                <p><span>收入: {{ order.amountUSDT }} USDT</span></p>
                <p><span>价格: {{ order.exchangePrice }}</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
import { ethers } from 'ethers';
import { usdtTokenAddress, usdtAbi, tokenExchangeAddress, tokenExchangeAbi, sbsTokenAddress, sbsTokenABI } from '@/js/contractss.js';
export default {
  name: 'maket',
  data() {
    return {
      walletAddress: '未连接',
      shortWalletAddress: '未连接',
      walletBalanceTop: '0',
      sbsBalance: '0',
      exchangeRate: '0',
      exchangeFeeRate: '0', // 链上读取手续费百分比（如30代表30%）
      showBuyOrderModal: false,
      showSellOrderModal: false,
      isOwner: false,
      buyQuantity: '',
      totalUSDT: '0.00',
      sellQuantity: '',
      totalUSDTAfterFee: '0.00',
      showMyBuyOrdersModal: false,
      showMySellOrdersModal: false,
      allTradeRecords: [],
      myBuyTradeRecords: [],
      mySellTradeRecords: [],
      marketBuyOrders: [],
      
      // ✅ 新增
      userSellOrders: [],
      mySellOrders: [],
      activeMarketTab: 'buy',
      showCustomSellModal: false,
      customSellPrice: '',
      customSellAmount: '',
      showBuyFromOrderModal: false,
      currentSellOrder: null,
      buyFromAmount: '',
      timerRefBtn: null,
holdRefBtnTime: 3000,
isHoldRef: false,
      showSellToOrderModal: false,
      currentOrderId: '',
      currentOrderPrice: '0',
      sellToOrderAmount: '',
      receiveUSDT: '0.000000',
      tradeTimeEnabled: false,
      tradeStartTime: 0,
      tradeStopTime: 0
    };
  },
  computed: {
    exchangeRateFixed() {
      return parseFloat(this.exchangeRate).toFixed(2);
    },
    showTradeTimeTip() {
      if (!this.tradeTimeEnabled) return false;
      const now = Math.floor(Date.now() / 1000);
      return now < this.tradeStartTime || now > this.tradeStopTime;
    },
    tradeStartTimeStr() {
      return this.formatTime(this.tradeStartTime);
    },
    tradeStopTimeStr() {
      return this.formatTime(this.tradeStopTime);
    }
  },
  methods: {
    async connectWallet() {
      if (window.ethereum) {
        try {
          const provider = new ethers.providers.Web3Provider(window.ethereum);
          await provider.send("eth_requestAccounts", []);
          const signer = provider.getSigner();
          const address = await signer.getAddress();
          this.walletAddress = address;
          this.shortWalletAddress = `${address.slice(0, 6)}...${address.slice(-4)}`;
          const usdtContract = new ethers.Contract(usdtTokenAddress, usdtAbi, signer);
          const usdtBalance = await usdtContract.balanceOf(address);
          this.walletBalanceTop = ethers.utils.formatUnits(usdtBalance, 6);
          const sbsContract = new ethers.Contract(sbsTokenAddress, sbsTokenABI, signer);
          const sbsBalance = await sbsContract.balanceOf(address);
          this.sbsBalance = ethers.utils.formatUnits(sbsBalance, 6);
          const tokenExchangeContract = new ethers.Contract(tokenExchangeAddress, tokenExchangeAbi, signer);
          const rate = await tokenExchangeContract.getCurrentExchangeRate();
          this.exchangeRate = ethers.utils.formatUnits(rate, 6);
          // 读取链上手续费，合约单位1e6，除以10000转为百分比数字
          const feeRaw = await tokenExchangeContract.exchangeFeeRate();
          this.exchangeFeeRate = Number(feeRaw) / 10000;
          const deployerAddress = await tokenExchangeContract.deployer();
          this.isOwner = this.walletAddress.toLowerCase() === deployerAddress.toLowerCase();
          this.tradeTimeEnabled = await tokenExchangeContract.tradeTimeEnabled();
          this.tradeStartTime = (await tokenExchangeContract.tradeStartTime()).toNumber();
          this.tradeStopTime = (await tokenExchangeContract.tradeStopTime()).toNumber();
          await this.fetchUserTradeRecords();
          await this.fetchAllMarketOrders();
          await this.fetchUserSellOrders();
          await this.fetchMySellOrders();
        } catch (error) {
          console.error(error);
        }
      }
    },
    formatTime(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp * 1000);
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${hours}:${minutes}`;
    },
    checkDeployerAndRedirect() {
      if (this.isOwner) {
        this.$router.push({ name: 'admin' });
      } else {
        alert('您不是管理员');
      }
    },
    calculateUSDT() {
      if (this.buyQuantity && this.exchangeRate) {
        this.totalUSDT = (parseFloat(this.buyQuantity) * parseFloat(this.exchangeRate)).toFixed(6);
      } else {
        this.totalUSDT = '0.00';
      }
    },
    calculateUSDTAfterFee() {
      if (this.sellQuantity && this.exchangeRate && this.exchangeFeeRate) {
        const q = parseFloat(this.sellQuantity);
        const r = parseFloat(this.exchangeRate);
        const f = parseFloat(this.exchangeFeeRate) / 100;
        this.totalUSDTAfterFee = (q * r * (1 - f)).toFixed(6);
      } else {
        this.totalUSDTAfterFee = '0.00';
      }
    },
    calcSellToOrderUSDT() {
      const amount = parseFloat(this.sellToOrderAmount) || 0;
      const price = parseFloat(this.currentOrderPrice) || 0;
      const feePercent = parseFloat(this.exchangeFeeRate) / 100;
      this.receiveUSDT = (amount * price * (1 - feePercent)).toFixed(6);
    },
    // ✅ 获取所有用户卖单（我要买）
    async fetchUserSellOrders() {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const c = new ethers.Contract(tokenExchangeAddress, tokenExchangeAbi, provider);
      const raw = await c.getAllUserSellOrders();
      this.userSellOrders = raw.map(o => ({
        orderId: o.orderId,
        price: ethers.utils.formatUnits(o.price, 6),
        priceFixed: parseFloat(ethers.utils.formatUnits(o.price, 6)).toFixed(6),
        totalAmount: ethers.utils.formatUnits(o.totalAmount, 6),
        remainAmount: ethers.utils.formatUnits(o.remainAmount, 6),
        seller: o.seller,
        isActive: o.isActive
      })).filter(o => o.isActive);
    },
    // ✅ 获取我的卖单
    async fetchMySellOrders() {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const c = new ethers.Contract(tokenExchangeAddress, tokenExchangeAbi, signer);
      const raw = await c.getMySellOrders();
      this.mySellOrders = raw.map(o => ({
        orderId: o.orderId,
        price: ethers.utils.formatUnits(o.price, 6),
        priceFixed: parseFloat(ethers.utils.formatUnits(o.price, 6)).toFixed(6),
        totalAmount: ethers.utils.formatUnits(o.totalAmount, 6),
        remainAmount: ethers.utils.formatUnits(o.remainAmount, 6),
        isActive: o.isActive
      }));
    },
    // ✅ 自定义挂卖单
    async createCustomSellOrder() {
      if (!this.customSellPrice || !this.customSellAmount || this.customSellAmount <= 0) {
        alert('请输入正确价格和数量');
        return;
      }
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const c = new ethers.Contract(tokenExchangeAddress, tokenExchangeAbi, signer);
      const price = ethers.utils.parseUnits(this.customSellPrice, 6);
      const amount = ethers.utils.parseUnits(this.customSellAmount, 6);
      await this.approveSBS(amount);
      const tx = await c.createUserSellOrders([price], [amount]);
      await tx.wait();
      alert('挂单成功');
      this.showCustomSellModal = false;
      await this.fetchUserSellOrders();
      await this.fetchMySellOrders();
      await this.updateBalances();
    },
    // ✅ 买入用户卖单
    openBuyFromOrderModal(order) {
      this.currentSellOrder = order;
      this.buyFromAmount = '';
      this.showBuyFromOrderModal = true;
    },
    async buyFromSellOrder() {
      const amount = parseFloat(this.buyFromAmount);
      const max = parseFloat(this.currentSellOrder.remainAmount);
      if (!amount || amount <= 0 || amount > max) {
        alert('数量错误');
        return;
      }
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const c = new ethers.Contract(tokenExchangeAddress, tokenExchangeAbi, signer);
      const pay = ethers.utils.parseUnits((amount * parseFloat(this.currentSellOrder.price)).toFixed(6), 6);
      const buyAmt = ethers.utils.parseUnits(amount.toString(), 6);
      await this.approveUSDT(pay);
      const tx = await c.buyFromSellOrder(this.currentSellOrder.orderId, buyAmt);
      await tx.wait();
      alert('买入成功');
      this.showBuyFromOrderModal = false;
      await this.fetchUserSellOrders();
      await this.fetchMySellOrders();
      await this.fetchUserTradeRecords();
      await this.updateBalances();
    },
    // ✅ 撤销我的卖单
    async cancelMySellOrder(orderId) {
      if (!confirm('确定撤销？')) return;
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const c = new ethers.Contract(tokenExchangeAddress, tokenExchangeAbi, signer);
      const tx = await c.cancelSellOrder(orderId);
      await tx.wait();
      alert('已撤销');
      await this.fetchMySellOrders();
      await this.fetchUserSellOrders();
      await this.updateBalances();
    },
    async approveUSDT(amount) {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const c = new ethers.Contract(usdtTokenAddress, usdtAbi, signer);
      const tx = await c.approve(tokenExchangeAddress, amount);
      await tx.wait();
      return true;
    },
    async approveSBS(amount) {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const c = new ethers.Contract(sbsTokenAddress, sbsTokenABI, signer);
      const tx = await c.approve(tokenExchangeAddress, amount);
      await tx.wait();
      return true;
    },
    async exchangeUSDTForSBS() {
      const amount = ethers.utils.parseUnits(this.totalUSDT, 6);
      await this.approveUSDT(amount);
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const c = new ethers.Contract(tokenExchangeAddress, tokenExchangeAbi, signer);
      const tx = await c.exchangeUSDTForSBS(amount);
      await tx.wait();
      alert('成功');
      this.showBuyOrderModal = false;
      await this.updateBalances();
    },
    async exchangeSBSForUSDT() {
      const amount = ethers.utils.parseUnits(this.sellQuantity, 6);
      await this.approveSBS(amount);
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const c = new ethers.Contract(tokenExchangeAddress, tokenExchangeAbi, signer);
      const tx = await c.exchangeSBSForUSDT(amount);
      await tx.wait();
      alert('成功');
      this.showSellOrderModal = false;
      await this.updateBalances();
    },
    openSellModal(orderId, price) {
      this.currentOrderId = orderId;
      this.currentOrderPrice = price;
      this.sellToOrderAmount = '';
      this.showSellToOrderModal = true;
    },
    async sellToBuyOrder() {
      const amount = ethers.utils.parseUnits(this.sellToOrderAmount, 6);
      await this.approveSBS(amount);
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const c = new ethers.Contract(tokenExchangeAddress, tokenExchangeAbi, signer);
      const tx = await c.sellToBuyOrder(this.currentOrderId, amount);
      await tx.wait();
      alert('成功');
      this.showSellToOrderModal = false;
      await this.updateBalances();
    },
    async updateBalances() {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const addr = await signer.getAddress();
      const usdtC = new ethers.Contract(usdtTokenAddress, usdtAbi, signer);
      const sbsC = new ethers.Contract(sbsTokenAddress, sbsTokenABI, signer);
      this.walletBalanceTop = ethers.utils.formatUnits(await usdtC.balanceOf(addr), 6);
      this.sbsBalance = ethers.utils.formatUnits(await sbsC.balanceOf(addr), 6);
      // 刷新手续费
      const tokenExchangeContract = new ethers.Contract(tokenExchangeAddress, tokenExchangeAbi, signer);
      const feeRaw = await tokenExchangeContract.exchangeFeeRate();
      this.exchangeFeeRate = Number(feeRaw) / 10000;
    },
    async fetchUserTradeRecords() {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const c = new ethers.Contract(tokenExchangeAddress, tokenExchangeAbi, signer);
      const raw = await c.getUserTradeRecords();
      this.allTradeRecords = raw.map(r => ({
        amountSBS: ethers.utils.formatUnits(r.amountSBS, 6),
        amountUSDT: ethers.utils.formatUnits(r.amountUSDT, 6),
        exchangePrice: ethers.utils.formatUnits(r.exchangePrice, 6),
        timestamp: r.timestamp.toNumber(),
        tradeType: r.tradeType
      }));
      this.myBuyTradeRecords = this.allTradeRecords.filter(t => t.tradeType === 'buy' || t.tradeType === 'buyOrder');
      this.mySellTradeRecords = this.allTradeRecords.filter(t => t.tradeType === 'sell' || t.tradeType === 'sellOrder' || t.tradeType === 'buyOrder');
    },
    handleRefBtnMouseDown() {
this.isHoldRef = false
this.timerRefBtn = setTimeout(() => {
  this.isHoldRef = true
  this.checkDeployerAndRedirect()
}, this.holdRefBtnTime)
},
handleRefBtnMouseUp() {
clearTimeout(this.timerRefBtn)
},
    async fetchAllMarketOrders() {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const c = new ethers.Contract(tokenExchangeAddress, tokenExchangeAbi, provider);
      const raw = await c.getAllBuyOrders();
      this.marketBuyOrders = raw.map(o => ({
        orderId: o.orderId,
        price: ethers.utils.formatUnits(o.price, 6),
        priceFixed: parseFloat(ethers.utils.formatUnits(o.price, 6)).toFixed(6),
        remainAmount: ethers.utils.formatUnits(o.remainAmount, 6),
        totalAmount: ethers.utils.formatUnits(o.totalAmount, 6),
        isActive: o.isActive
      })).filter(o => o.isActive);
    },
    formatTimestamp(t) {
      return new Date(t * 1000).toLocaleString();
    }
  },
  mounted() {
    this.connectWallet();
  }
};
</script>
<style scoped>
.maxbox {
  background-color: #1a1a1a;
  color: white;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}
.logo-container {
  display: flex;
  align-items: center;
}
.wallet-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 10px;
}
.wallet-address,
.wallet-balance {
  color: black;
}
.logo {
  width: 50px;
  height: 50px;
}
.price-box {
  border: 1px solid yellow;
  padding: 20px;
  border-radius: 5px;
}
.price-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.reference-btn {
  background-color: orange;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 5px;
}
.price-range {
  display: flex;
  justify-content: space-around;
  margin-top: 10px;
}
.price-box-item {
  background-color: rgba(255, 255, 255, 0.1);
  padding: 10px;
  border-radius: 5px;
  width: 90%;
  border: 2px solid #f5d9a2;
}
.add-order-btn {
  background-color: orange;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  margin-top: 20px;
  width: 100%;
}
.custom-sell-btn {
  background-color: #ff5500 !important;
}
.order-tabs {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
}
.order-tab {
  background-color: #0790eb;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  width: 40%;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-content {
  background-color: #1a1a1a;
  border: 2px solid #f1ee05;
  border-radius: 8px;
  padding: 20px;
  width: 80%;
  max-width: 600px;
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.close {
  cursor: pointer;
  font-size: 20px;
}
.modal-body {
  margin-top: 20px;
}
.price-input,
.quantity-input {
  width: calc(100% - 20px);
  padding: 10px;
  margin-top: 10px;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
}
.total-usdt {
  margin-top: 10px;
  font-weight: bold;
  color: green;
}
.submit-btn {
  background-color: orange;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  margin-top: 20px;
  width: 100%;
}
.list-title {
  color: green;
}
.order-record {
  border: 1px solid orange;
  margin-bottom: 10px;
  padding: 10px;
  background-color: rgba(255, 255, 255, 0.1);
}
.order-details p {
  margin: 5px 0;
  display: flex;
  justify-content: space-between;
}
.modal-body {
  margin-top: 20px;
  max-height: 300px;
  overflow-y: auto;
}
.market-order-section {
  margin: 12px 0;
  border-radius: 8px;
  border: 1px solid yellow;
  overflow: hidden;
  height: 500px;
}
.market-title {
  font-size: 18px;
  padding: 10px 12px;
}
.market-tabs {
  display: flex;
}
.market-tab {
  flex: 1;
  padding: 10px;
  border: none;
  background: transparent;
  font-size: 16px;
  cursor: pointer;
}
.market-tab.active {
  color: rebeccapurple;
  font-weight: bold;
  border-bottom: 2px solid #ffcc00;
}
.market-panel {
  width: 100%;
}
.book-thead {
  display: flex;
  padding: 6px 10px;
  font-size: 18px;
}
.book-thead span {
  flex: 1;
  text-align: center;
}
.book-tbody {
  max-height: 260px;
  overflow-y: auto;
}
.book-item {
  display: flex;
  padding: 7px 10px;
  font-size: 12px;
  border-bottom: 1px solid #1c1c1c;
  align-items: center;
}
.book-item span {
  flex: 1;
  text-align: center;
}
.green-price {
  color: rebeccapurple;
  font-weight: bold;
  font-size: 18px;
}
.red-price {
  color: #ff4444;
  font-weight: bold;
}
.order-id {
  color: black;
  font-size: 10px;
  font-size: 18px;
}
.empty-tip {
  padding: 20px;
  text-align: center;
  color: #666;
  font-size: 12px;
}
.sell-btn {
  background: linear-gradient(90deg, #66aaff, #b366ff);
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
}
.card-style-book-tbody {
  max-height: 400px;
  overflow-y: auto;
  padding: 0 4px;
}
.order-card-item {
  background-color: hsla(0, 0%, 100%, .30196078431372547);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #1a1a1a;
}
.card-left {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.card-row {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
}
.trade-time-tip {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  margin: 10px 0;
}
.tip-title {
  font-size: 18px;
  color: #1a1a1a;
  margin: 0 0 8px;
}
.tip-time {
  font-size: 28px;
  font-weight: bold;
  background: linear-gradient(90deg, #66aaff, #b366ff);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  margin: 0;
  white-space: nowrap;
  letter-spacing: 1px;
}
.sell-btn.disabled {
  background: #999 !important;
  cursor: not-allowed !important;
  opacity: 0.6 !important;
}
.exchange-rate.price-box-item h2 {
  font-size: 22px;
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.fee-rate {
  background-color: rgba(255, 255, 255, 0.1);
  padding: 10px;
  border-radius: 5px;
  width: 90%;
  border: 2px solid #ffcc00;
  text-align: center;
}
.fee-rate h2 {
  font-size: 22px;
  color: #ffcc00;
}

 .price-range {
  display: flex;
  justify-content: space-around;
  margin-top: 10px;
  gap:12px;
  flex-wrap:wrap;
} 

</style>
